export function canManageCapabilities(role: string): boolean {
  return role === 'RESTAURANT';
}

export async function graphqlFetch({
  query,
  variables,
}: {
  query: string;
  variables?: Record<string, unknown>;
}): Promise<any> {
  const token = localStorage.getItem('console_token');
  const response = await fetch('/graphql', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ query, variables }),
  });
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    return { errors: [{ message: text }] };
  }
}

export async function fetchRestaurantIdByEmail({ email }: { email: string }): Promise<string | null> {
  // GraphQL variables — never string-interpolate user input into the query
  // string. Interpolating `email` here previously enabled injection of full
  // additional mutations against the admin schema (INJ-VULN-01, INJ-VULN-05).
  const json = await graphqlFetch({
    query: `query AdminUsersByEmail($email: String!, $role: String) {
      adminUsers(search: $email, first: 1, role: $role) { edges { node { restaurant { id } } } }
    }`,
    variables: { email, role: 'RESTAURANT' },
  });
  return json?.data?.adminUsers?.edges?.[0]?.node?.restaurant?.id ?? null;
}
